import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.04 9.19L17.45 10.6L6.05 22H2V17.95L13.4 6.55L14.81 7.96L4 18.78V20H5.22L16.04 9.19ZM17.95 2L14.82 5.13L16.23 6.54L17.95 4.82L19.18 6.04L17.46 7.76L18.87 9.17L22 6.04L17.95 2Z" fill={ fill || 'currentColor' } />
    </svg>
);
